import { resolveApiUrl } from "../../../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/cart/deleteSection");

export function apiDeleteCartSection(quoteNumber?: string): Promise<void> {
  let finalUrl = apiUrl;
  if (quoteNumber !== undefined) {
    finalUrl += `?quoteNumber=${quoteNumber}`;
  }
  return fetch(finalUrl, {
    method: "DELETE",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Error when clearing section");
      }
    })
    .then((result) => {
      window.SCHA.updateMinicart?.();
      return result;
    });
}
